export default () => ({
	open: '',
	preselected: '',
	openItem(title) {
		if (this.open !== title) {
			this.open = title;
		} else {
			this.open = '';
		}
	},

	init() {
		this.$watch('preselected', () => {
			if (window.innerWidth < 1024 && this.preselected) {
				this.open = this.preselected;
			}
		});
	},
});
